export default "__VITE_ASSET__DWP5nizU__"